import { MAX_FEATURE_REQUEST_LENGTH } from '@ergo/shared';
import { type FormEvent, useState } from 'react';
import { api, errorMessage } from '../../api';
import { useResource } from '../../hooks';
import { formatDate } from '../../time';

/** Her own backlog: what she wishes the app did, written down as it comes. */
export function Demandes() {
  const requests = useResource(() => api.featureRequests.list(), []);
  const [text, setText] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run(action: () => Promise<unknown>) {
    setPending(true);
    setError(null);
    try {
      await action();
      requests.reload();
    } catch (cause) {
      setError(errorMessage(cause));
    } finally {
      setPending(false);
    }
  }

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    const wish = text.trim();
    if (!wish) return;
    await run(async () => {
      await api.featureRequests.create(wish);
      setText('');
    });
  }

  return (
    <section className="panel">
      <h2 className="panel__title">Demander une fonctionnalité</h2>

      <form className="form" onSubmit={onSubmit}>
        <label className="field">
          <span className="field__label">Votre idée</span>
          <textarea
            className="input input--textarea"
            rows={3}
            maxLength={MAX_FEATURE_REQUEST_LENGTH}
            placeholder="Ce que l’application devrait savoir faire…"
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
        </label>

        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}

        <div className="form__actions">
          <button
            className="button button--primary"
            type="submit"
            disabled={pending || !text.trim()}
          >
            {pending ? 'Envoi…' : 'Envoyer'}
          </button>
        </div>
      </form>

      {requests.error && (
        <p className="error" role="alert">
          {requests.error}
        </p>
      )}
      {requests.data?.length === 0 && <p className="empty">Aucune demande pour l’instant.</p>}

      <ul className="list">
        {(requests.data ?? []).map((item) => (
          <li key={item.id}>
            <div className="list__row">
              <span className="demande__text">{item.text}</span>
              <span className="muted">{formatDate(item.createdAt.slice(0, 10))}</span>
              <span className="list__actions">
                <button
                  type="button"
                  className="button button--small button--danger"
                  disabled={pending}
                  onClick={() => void run(() => api.featureRequests.remove(item.id))}
                >
                  Supprimer
                </button>
              </span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
